<template>
  <div id="topics-areas">
    <div class="info">
      <div class="row">
        <div class="col-sm-12 text-center">
          <h3>Temas</h3>
        </div>
      </div>
      <loading v-if="isLoading"></loading>
      <ul class="grid grid-5-columns" v-if="!isLoading">
        <li v-for="topic in topics" :key="topic.id">
          <router-link :to="{name:'home', params:{type: 'tematica', slug: topic.slug}}" v-on:click.native="goToDataView" >
            <img :src="topic.image">
            <span class="img-caption">{{topic.name}}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  /* global $ */
  import axios from 'axios';
  import scrollTo from 'vue-scrollto';

  import Loading from './Loading';


  /* global datos_abiertos */
  export default {
    name: 'topics-areas',
    components: {
      Loading,
    },
    methods: {
      goToDataView() {
        scrollTo.scrollTo('#view-data', 500);
      },
    },
    data() {
      return {
        topics: [],
        isLoading: true,
      };
    },
    created() {
      const apiUrl = datos_abiertos.api_url;
      axios.get(`${apiUrl}/wp-json/datos-abiertos/v1/tematicas`).then((response) => {
        this.isLoading = false;
        if (response.status === 200) {
//          console.log(response.data);
          this.topics = response.data;
        }
      }).catch((e) => {
        this.error = e;
        console.log(this.error);
      });
    },
  };
</script>

<style>
  #topics-areas ul li,
  #topics-areas ul {
    list-style: none !important;
  }

  #topics-areas .grid {
    padding: 0;
    list-style: none;
    overflow: hidden;
  }

  #topics-areas .grid.grid-5-columns li, .grid.grid-5-columns figure {
    width: 20%;
  }

  #topics-areas .grid li {
    float: left;
    position: relative;
    width: 20%;
    padding: 20px;
  }

  #topics-areas .grid li:before {
    height: 100%;
    top: 0;
    left: -1px;
    border-left: 1px solid #eee;
  }

  #topics-areas .grid li:after {
    width: 100%;
    height: 0;
    top: auto;
    left: 0;
    bottom: -1px;
    border-bottom: 1px solid #eee;
  }

  #topics-areas .grid li:before, .grid li:after {
    content: '';
    position: absolute;
  }

  #topics-areas .grid li:hover {
    cursor: pointer;
    background-color: #f8f8f8;
  }

  #topics-areas .grid li, .clients-carousel a,
  #topics-areas .clients-carousel a img {
    -webkit-transition: all 0.5s ease 0s;
    transition: all 0.5s ease 0s;
    opacity: 0.8;
  }

  #topics-areas .grid li a img {
    width: 100%;
  }

  #topics-areas .grid li a, .grid li img {
    display: block;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  #topics-areas .grid li a .img-caption {
    font-size: 13px;
    text-align: center;
    color: #292b2c;
    width: 100%;
    display: inline-block;
    font-weight: 700;

  }
  @media (max-width: 700px) {
    #topics-areas .grid.grid-5-columns li,
    .grid.grid-5-columns figure{
      width: 50%;
    }

    #data-lists .table-striped thead{
      display: none;
    }

    #data-lists .table-striped tbody tr{
      border-top: 1px solid #eceeef;
    }
    #data-lists .table-striped tbody tr td{
      width:100%;
      display: inline-block;
      border-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// TopicsAreas.vue?f1cee962